import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { Toaster } from '@/shared/components/ui/toaster'
import { BottomNav } from '@/shared/components/bottom-nav'
import { Header } from '@/shared/components/header'
import { AuthDialogs } from '@/features/auth/components/AuthDialogs'
import { REFERRAL_CODE_QUERY_PARAM, storeReferralCode } from '@/features/auth/lib/referral'
import { hasRefreshToken } from '@/shared/lib/auth-session'
import { useAuthStore } from '@/shared/stores/auth'
import { useCountryStore } from '@/shared/stores/country'

export default function App() {
  const location = useLocation()
  const checkSession = useAuthStore((state) => state.checkSession)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const user = useAuthStore((state) => state.user)
  const setCountry = useCountryStore((state) => state.setCountry)

  useEffect(() => {
    checkSession()
  }, [checkSession])

  useEffect(() => {
    if (isAuthenticated || hasRefreshToken()) return

    const referralCode = new URLSearchParams(location.search).get(REFERRAL_CODE_QUERY_PARAM)
    if (referralCode) {
      storeReferralCode(referralCode)
    }
  }, [isAuthenticated, location.search])

  useEffect(() => {
    if (user?.prefCountry) {
      localStorage.setItem('preferredCountry', user.prefCountry)
      setCountry(user.prefCountry)
    }
  }, [user?.prefCountry, setCountry])

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="mx-auto max-w-7xl px-4 pb-24 pt-4 md:pb-8">
        <Outlet />
      </main>
      <BottomNav />
      <Toaster />
      <AuthDialogs />
    </div>
  )
}
